module.exports = __webpack_public_path__ + "assets/ac922a8f3f76b92467e6c6f83f5bf12c.mp3";